import Vue from 'vue';
import Vuetify from 'vuetify';
import FileIcon from '@/components/File_icon.vue';
import FolderIcon from '@/components/Folder_icon.vue';
import ThemeGeodis from './theme.geodis';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

// Define the geodis colors in the theme.geodis file.
const opts = {
  theme: {
    themes: { light: ThemeGeodis },
  },
  icons: {
    values: {
      fileIcon: {
        component: FileIcon,
      },
      folderIcon: {
        component: FolderIcon,
      },
    },
  },
};

export default new Vuetify(opts);
